import { useState } from "react";
import { UserPlus, UserCheck, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../lib/api";

export default function FollowButton({ userId, following, onChange, size = "sm" }) {
  const [busy, setBusy] = useState(false);
  const toggle = async () => {
    setBusy(true);
    try { const { data } = await api.post(`/community/members/${userId}/follow`); onChange?.(data); toast.success(data.is_following ? "Following" : "Unfollowed"); }
    catch (e) { toast.error(e?.response?.data?.detail || "Could not update follow"); }
    finally { setBusy(false); }
  };
  const h = size === "md" ? "h-10 px-4 text-sm" : "h-8 px-3 text-sm";
  const Icon = busy ? Loader2 : following ? UserCheck : UserPlus;
  return (
    <button onClick={toggle} disabled={busy} data-testid={`follow-btn-${userId}`} aria-pressed={!!following}
      className={`${h} inline-flex items-center gap-1.5 rounded-${size === "md" ? "full" : "md"} font-semibold transition-colors ${following ? "border border-cyan-400/60 text-cyan-300 hover:bg-cyan-400/10" : "border border-slate-700 text-slate-200 hover:bg-slate-800"}`}>
      <Icon className={`w-3.5 h-3.5 ${busy ? "animate-spin" : ""}`} />{following ? "Following" : "Follow"}
    </button>
  );
}
